import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import useEmailVerificationResend from '@shared/hooks/useEmailVerificationResend';
import { useTranslation } from 'react-i18next';
import Button from '../../core/button/CoreButton';
import PageBannerCard from '../../core/card/PageBannerCard';

export default function NoEmailVerifiedBanner() {
    const { t } = useTranslation();
    const { handleResendVerification } = useEmailVerificationResend();
    const currentUser = useCurrentUserStore((state) => state.currentUser);
    const isLoading = useCurrentUserStore((state) => state.isLoading);

    if (!currentUser || isLoading || currentUser.isEmailVerified) return null;
    return (
        <PageBannerCard
            description={t('common:account.isEmailVerified.org')}
            fullHeight
            icon="orgInvite"
            title={t('common:account.isEmailVerified.title')}>
            <Button onClick={handleResendVerification} startIcon="sync">
                {t('common:account.isEmailVerified.resend')}
            </Button>
        </PageBannerCard>
    );
}
